import action from './action';
import auth from './auth';
import nav from './nav';
import start from './start';
import order from './order';
import thankYou from './thankYou';
import form from './form';
import summary from './summary';
import deletePage from './delete';
import team from './team';

export default {
  action,
  auth,
  nav,
  start,
  order,
  thankYou,
  form,
  summary,
  deletePage,
  team,
};
